import type { ReactNode } from 'react';

import { applyCypressData } from 'Utilities/helpers';

import styles from './InsightCard.module.scss';

type InsightCardProps = {
	cypressId?: string;
	title: ReactNode;
	value: string;
};

export const InsightCard: React.FC<InsightCardProps> = ({ cypressId, title, value }) => {
	return (
		<div className={styles.insightCard} data-testid={'insight-card'} {...applyCypressData(cypressId)}>
			<h2 className={styles.cardTitle}>{title}</h2>
			<span className={styles.cardValue}>{value}</span>
		</div>
	);
};
